module.exports = __webpack_public_path__ + "img/octoih-1763-pagina-de-titlu-big.719aa40d.jpg";